import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { AppLoginContainerModel } from '../../../../../models/aggregates/id';
import { ApiVisa } from '..';




@Injectable({
    providedIn: 'root'
})
export class UserService extends BaseApiTemplateService<AppLoginContainerModel> {

    readonly url = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'users';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'users';
        this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'users';
        this.httpClient = http;
    }

    // checkUserByEmailAsTenantAdminForCatalogue(catalogueGuid: string, email: string, apiVisa: ApiVisa) {

    //     this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/login-tenant-ep/' + catalogueGuid + '?email=' + email + "&tenantCode=" + apiVisa.tenantCode;

    //     return this.httpClient.get(this.apiUrl, this.getHttpHeader(apiVisa));
    // }

    checkUserByEmailAsTenantAdminForCatalogue(catalogueGuid: string, apiVisa: ApiVisa, email?: string, mobileNumber?: string) {
        let queryParams = [];
    
        queryParams.push(`tenantCode=${apiVisa.tenantCode}`);
    
        if (email) queryParams.push(`email=${email}`);
        if (mobileNumber) queryParams.push(`mobileNumber=${mobileNumber}`);
    
        const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";
        this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/login-tenant-ep/' + catalogueGuid + queryString;
    
        return this.httpClient.get(this.apiUrl, this.getHttpHeader(apiVisa));
    }
    

    sendInviationAsTenantAdminForCatalogue(request: any, guid: string, apiVisa: ApiVisa) {

        this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/login-tenant-ep/' + guid + '?tenantCode=' + apiVisa.tenantCode;

        return this.httpClient.post(this.apiUrl, request, this.getHttpHeader(apiVisa));
    }

    checkUserByEmailAsSysadminForCatalogue(catalogueGuid: string, apiVisa: ApiVisa, email?: string, mobileNumber?: string) {
        let queryParams = [];

        if (email) queryParams.push(`email=${email}`);
        if (mobileNumber) queryParams.push(`mobileNumber=${mobileNumber}`);
      
        const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";
        this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/catalog/sysadmin-ep/' + catalogueGuid + queryString;

        return this.httpClient.get(this.apiUrl, this.getHttpHeader(apiVisa));
    }

    checkUserByEmailAsSysadminForTeanat(tenantGuid: string, apiVisa: ApiVisa, email?: string, mobileNumber?: string) {
        let queryParams = [];

        if (email) queryParams.push(`email=${email}`);
        if (mobileNumber) queryParams.push(`mobileNumber=${mobileNumber}`);
      
        const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";
        this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/tenant/sysadmin-ep/' + tenantGuid + queryString;

        return this.httpClient.get(this.apiUrl, this.getHttpHeader(apiVisa));
    }


    checkAdminUserAsTenantAdmin(tenantGuid: string, apiVisa: ApiVisa, email?: string, mobileNumber?: string) {
        let queryParams = [];
    
        if (email) queryParams.push(`email=${email}`);
        if (mobileNumber) queryParams.push(`mobileNumber=${mobileNumber}`);
    
        const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";
        this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/tenant-admin-ep/' + tenantGuid + queryString;
    
        return this.httpClient.get(this.apiUrl, this.getHttpHeader(apiVisa));
    }

    // /core2/platform/dm/users/send-invitation/tenant-admin-ep/{tenantCode}
    sendInvitationAsTenantAdmin(request: any, apiVisa: ApiVisa) {
        this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/send-invitation/tenant-admin-ep/' + apiVisa.tenantCode;
        return this.httpClient.post(this.apiUrl, request, this.getHttpHeader(apiVisa));
    }

    // /core2/platform/dm/users/send-invitation/backoffice-ep/{tenantCode}
    sendInvitationBackOfficeEP(request: any, apiVisa: ApiVisa) {
        this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/send-invitation/backoffice-ep/' + apiVisa.tenantCode;
        return this.httpClient.post(this.apiUrl, request, this.getHttpHeader(apiVisa));
    }

}
